import DEFAULT_OPTIONS from '@map/sidebars/SavedItemsSidebar/DEFAULT_OPTIONS';

export type BreadcrumbNavigationAction =
    | {
          type: 'push';
          state: FolderDetailsSidebarState;
      }
    | {type: 'pop'}
    | {type: 'reset'}
    | {type: 'replace'; state: FolderDetailsSidebarState[]};

export default function breadcrumbNavigationStateReducer(
    breadcrumbs: FolderDetailsSidebarState[],
    action: BreadcrumbNavigationAction
): FolderDetailsSidebarState[] {
    switch (action.type) {
        case 'push': {
            // Check the last entry to ensure we're not pushing a duplicate onto the stack
            // Technically this could still push multiples out of order so maybe
            // we should change this to a `navigate` action that either pushes a new item
            // or navigates to an existing entry
            if (
                breadcrumbs.length > 0 &&
                breadcrumbs[breadcrumbs.length - 1].id === action.state.id
            ) {
                return breadcrumbs;
            }
            return [
                ...breadcrumbs,
                {
                    // Reset sidebar state when navigating forward
                    sort: DEFAULT_OPTIONS.sort,
                    filter: DEFAULT_OPTIONS.filter,
                    search: DEFAULT_OPTIONS.search,
                    scrollPosition: 0,
                    selections: [],
                    ...action.state,
                },
            ];
        }
        case 'pop': {
            return breadcrumbs.slice(0, -1);
        }
        case 'replace': {
            return [...action.state];
        }
        case 'reset': {
            return [];
        }
        default: {
            return breadcrumbs;
        }
    }
}
